import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
  updateDoc
} from "firebase/firestore";

import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
   RecaptchaVerifier,
  signInWithPhoneNumber
} from "firebase/auth";

import Cookies from "js-cookie";
import { Randomcode } from "./components_root/rendom_code";

// 🔥 Firebase Config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

provider.setCustomParameters({ prompt: "select_account" });

/* =====================================================
   GOOGLE LOGIN
===================================================== */

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    if (!user?.email) throw new Error("Email not found");

    const emailid = user.email.toLowerCase().trim();

    let account_guid = "";
    let displayName = user.displayName || "Unknown";
    let photoURL = user.photoURL || "";
    let currency_code = "INR";

    // 🔎 Check Existing Account
    const checkQuery = query(
      collection(db, "accounts"),
      where("email", "==", emailid)
    );

    const checkSnap = await getDocs(checkQuery);

    if (!checkSnap.empty) {
      const userDoc = checkSnap.docs[0];
      const userData = userDoc.data();

      account_guid = userData.guid;
      displayName = userData.name || displayName;
      photoURL = userData.photoURL || photoURL;
      currency_code = userData.currency_code || currency_code;

      await updateDoc(doc(db, "accounts", account_guid), {
        updated_date_time: new Date(),
      });

      console.log("✅ Existing user login");
    } else {
      // 🆕 Create New User
      account_guid = Randomcode(22);
      const slug = Randomcode(12).toLowerCase();

      await setDoc(doc(db, "accounts", account_guid), {
        guid: account_guid,
        uid: account_guid,
        email: emailid,
        name: displayName,
        photoURL,
        currency_code,
        referral_code: Randomcode(9),

        city: Cookies.get("city") || "",
        postcode: Cookies.get("postcode") || "",
        state: Cookies.get("state") || "",
        country: Cookies.get("country") || "",
        address: Cookies.get("address") || "",
        latitude: Cookies.get("latitude") || "",
        longitude: Cookies.get("longitude") || "",

        device: navigator.userAgent,
        deviceName: Cookies.get("deviceName") || "Unknown Device",

        rating: 1,
        reviews: 0,
        slug,
        status: true,
        verification: false,
        bio: "Short profile description",

        date_time: new Date(),
        updated_date_time: new Date(),
      });

      Cookies.remove("referral_code");

      console.log("✅ New user created");
    }

    /* =====================================================
       CREATE LOGIN SESSION
    ===================================================== */

    const sessionToken = Randomcode(18);

    await setDoc(doc(db, "accounts_login", sessionToken), {
      guid: account_guid,
      sessiontoken: sessionToken,
      name: displayName,
      email: emailid,
      photoURL,
      emailuid: user.uid,
      device: navigator.userAgent,
      deviceName: Cookies.get("deviceName") || "Unknown Device",
      app_version: "1.1.5",
      status: true,
      date_time: new Date(),
    });

    /* =====================================================
       COOKIE SETTINGS (PRODUCTION SAFE)
    ===================================================== */

    const hostname = window.location.hostname;
    const isHttps = window.location.protocol === "https:";
    const isLocalhost =
      hostname === "localhost" || hostname === "127.0.0.1";

    const cookieOptions = {
      expires: 90,
      path: "/",
      secure: isHttps,
      sameSite: isHttps ? "None" : "Lax",
      ...(isHttps && !isLocalhost && { domain: ".aooz.in" }),
    };

    // Clear old cookies
    Cookies.remove("sessiontoken", { path: "/" });
    Cookies.remove("guid", { path: "/" });

    // Set new cookies
    Cookies.set("username", displayName, cookieOptions);
    Cookies.set("sessiontoken", sessionToken, cookieOptions);
    Cookies.set("guid", account_guid, cookieOptions);
    Cookies.set("photoURL", photoURL, cookieOptions);

     return { success: true };

  } catch (error) {
    console.error("❌ Google Sign-In Error:", error);
    return { success: false };
  }
};

 

export const googleLogout = async () => {
  try {
    await signOut(auth); // optional but recommended

    const hostname = window.location.hostname;
    const isHttps = window.location.protocol === "https:";
    const isLocalhost =
      hostname === "localhost" || hostname === "127.0.0.1";

    const cookieOptions = {
      path: "/",
      ...(isHttps && !isLocalhost && { domain: ".aooz.in" }),
    };

    Cookies.remove("sessiontoken", cookieOptions);
    Cookies.remove("guid", cookieOptions);
    Cookies.remove("username", cookieOptions);
    Cookies.remove("photoURL", cookieOptions);

    window.location.href = "/";

  } catch (error) {
    console.error("❌ Logout Error:", error);
  }
};
 
 
export const checkUserAuth = (setUser) => {
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      const email = user.email?.toLowerCase();

      const q = query(
        collection(db, "accounts"),
        where("email", "==", email)
      );

      const snap = await getDocs(q);

      if (!snap.empty) {
        const data = snap.docs[0].data();

        setUser({
          guid: data.guid,
          email: data.email,
          name: data.name,
          photoURL: data.photoURL,
        });
      }
    } else {
      setUser(null);
    }
  });
};
export { auth, provider, db };